export var extractNumericPrefix = function (label) {
    if (!label)
        return "";
    var match = label.match(/č\.\s+([\d-]+)\//);
    return match ? match[1] : label;
};
